import { locationPageCrumbs } from "../structured-data-core";
import { serviceAreaSchema } from "./service-area";

export function getTampaStructuredData() {
  const url = "https://restorehair.com/locations/florida/tampa/";
  const description =
    "Find out about your hair transplant options in Tampa with RESTORE Hair. Over 20,000 procedures performed.";
  return [
    serviceAreaSchema("tampa", url, description),
    locationPageCrumbs(url, "Tampa"),
  ];
}
